module.exports = __webpack_public_path__ + "img/achtergrond.0c24383f.png";